<template>
  <div>
    <div
      class="text-truncate width-fixed ani-opacity-fade"
      @click="toggleCollapse"
      v-bind:class="{'opacity_hide' : showCollapse, 'd-none' : hideText}"
    >{{content}}</div>

    <b-collapse class="width-fixed" id="collapse-text" v-model="showCollapse">
      <div @click="toggleCollapse">{{content}}</div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "TextCollapse",
  props: ["content"],
  data() {
    return {
      showCollapse: false,
      hideText: false
    };
  },
  methods: {
    toggleCollapse() {
      this.showCollapse = !this.showCollapse;
      this.hideText = this.showCollapse;
    }
  }
};
</script>

<style scoped>
.width-fixed {
  max-width: 200px;
}

.opacity_hide {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/TextCollapse.vue